export const requestUrl =
  "https://cdn.cnbj1.fds.api.mi-img.com/lark-cms/assets/privacySupport-ad8eb1a7-25d7-4493-9261-253116d5618d.json";

export async function request(url: string, params: {}) {
  let response = await fetch(url, params);
  return response.json();
}
